import React from 'react';
export var TableContext = React.createContext(undefined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/grommet/es6/components/Table/TableContext.js
// module id = 57
// module chunks = 0